
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"14","viewBox":"0 0 21 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.85 2.566a.809.809 0 01-.606-.253A.865.865 0 010 1.688c0-.25.081-.458.244-.626A.81.81 0 01.85.81h3.617c.241 0 .443.084.606.253a.865.865 0 01.244.625.863.863 0 01-.244.626.81.81 0 01-.606.252H.85zm0 5.717a.809.809 0 01-.606-.253A.865.865 0 010 7.405c0-.25.081-.458.244-.626a.81.81 0 01.606-.252h3.617c.241 0 .443.084.606.253a.865.865 0 01.244.625.863.863 0 01-.244.626.81.81 0 01-.606.252H.85zm18.715 5.123L15.82 9.539c-.424.324-.89.57-1.395.74a4.84 4.84 0 01-1.547.255c-1.415 0-2.619-.513-3.61-1.538-.993-1.024-1.49-2.268-1.49-3.73 0-1.46.497-2.704 1.49-3.729C10.26.512 11.463 0 12.878 0s2.619.512 3.61 1.537c.993 1.025 1.49 2.268 1.49 3.73 0 .543-.083 1.076-.247 1.598a5.067 5.067 0 01-.717 1.44l3.744 3.867a.863.863 0 01.24.611.842.842 0 01-.24.623.8.8 0 01-.597.254.8.8 0 01-.597-.254zm-6.686-4.628c.944 0 1.747-.341 2.408-1.024.661-.683.992-1.512.992-2.487 0-.975-.331-1.805-.992-2.487-.66-.683-1.464-1.024-2.408-1.024s-1.747.341-2.408 1.024c-.661.682-.992 1.512-.992 2.487 0 .975.331 1.804.992 2.487s1.464 1.024 2.408 1.024zM.849 14a.809.809 0 01-.605-.252.864.864 0 01-.244-.626c0-.249.081-.457.244-.626a.81.81 0 01.606-.252h9.283c.241 0 .443.085.606.253a.865.865 0 01.244.626.863.863 0 01-.244.625.81.81 0 01-.606.252H.85z","fill":"currentColor"}})])
          )
        }
      }
    